import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {convertDate, getGetHeaders} from '../shared/functions';
import {setDefaultTableSort, filterCaseInsensitive, getTableState, sortNumber} from '../shared/tableFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import ReactTable from 'react-table';
import {RESOURCES as searchResources} from '../fuseSearchResourceMap';
import {tableStyles} from '../shared/styles-table';
import '../shared/react-table.css';

class MissingScansTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataComplete: false,
            dataList: [],
            dataTable: [],
            message: null
        };
        this.handleSortOrFilterChange = this.handleSortOrFilterChange.bind(this);
    }

    componentWillMount() {
        this.fetchData();
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.startDate !== this.props.startDate ||
            (!nextProps.listComplete && this.props.listComplete)
        ) {
            this.setState({
                dataComplete: false,
                dataList: [],
                dataTable: [],
                message: null
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.startDate !== this.props.startDate ||
            (prevProps.listComplete && !this.props.listComplete)
        ) {
            this.fetchData();
        }
    }

    /**
     * Get Scan data for selected Since Date
     *
     */
    fetchData() {
        const startDate = this.props.startDate;
        let startDateStr = '.';
        if (startDate) {
            const date = new Date(startDate);
            startDateStr = ' since ' + (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' + date.getUTCFullYear() + '.';
        }
        let errorMessage = 'Sorry, there was an error retrieving Scans.';
        let noneMessage = 'No Missing Scans' + startDateStr;
        let params = {
            filter: {
                date_since: startDate
            },
        };
        let resource = searchResources.MissingScans.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.error) {
                this.storeProcessedData([], false, errorMessage);
            } else if (result.data && result.data.length > 0 && result.data[0].scan) {
                this.processSearchData(result.data);
            } else if (result.data && result.data.payload) {
                this.processSearchData(result.data.payload);
            } else {
                this.storeProcessedData([], false, noneMessage);
            }
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
            } else if (error.request) {
                // No response
            } else {
            }
            this.storeProcessedData([], false, errorMessage);
        });
    }

    /**
     * Process array of Missing Scans
     *
     * @param data
     */
    processSearchData(data) {
        let processedData = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let dateLatestScan = convertDate(item.latest_scan);
            let result = {
                latest_scan_date: dateLatestScan,
                id: item.scan,
                found_product: (item.found_product) ? item.found_product : '(None)',
                found_sku: (item.found_sku) ? item.found_sku : '(None)',
                latest_scan: item.latest_scan,
                scan: item.scan,
                total_lookups: item.total_lookups
            };
            processedData.push(result);
        }
        this.storeProcessedData(processedData, true);
    }

    /**
     * Store data from processing and lift state
     *
     * @param data
     * @param success
     * @param message
     */
    storeProcessedData(data, success, message = null) {
        this.setState({
            dataComplete: true,
            dataList: data,
            dataTable: data,
            message: message
        }, () => {
            this.props.onDataComplete(true);
        });
    }

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortOrFilterChange(event, table) {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            this.setState({
                dataTable: tableData
            });
        }
    }

    render() {
        const {
            dataComplete,
            dataList,
            message
        } = this.state;

        const defaultSort = setDefaultTableSort({field: 'latest_scan', order: 'ASC'});

        const tableColumns = [
            {
                Header: '',
                accessor: 'latest_scan_date',
                style: tableStyles.hide,
                headerStyle: tableStyles.hide
            },
            {
                Header: () => (<span>Last<br/>Scanned</span>),
                accessor: 'latest_scan',
                Cell: props => (
                    <span>{props.row.latest_scan_date}</span>
                ),
                headerStyle: tableStyles.left
            },
            {
                Header: 'Barcode',
                accessor: 'scan',
                headerStyle: tableStyles.left
            },
            {
                Header: () => (<span>Found<br/>SKU</span>),
                accessor: 'found_sku',
                headerStyle: tableStyles.left
            },
            {
                Header: () => (<span>Found<br/>Product</span>),
                accessor: 'found_product',
                headerStyle: tableStyles.left
            },
            {
                Header: () => (<span>Total<br/>Lookups</span>),
                accessor: 'total_lookups',
                sortMethod: (a, b) => sortNumber(a, b),
                filterable: false,
                style: tableStyles.right,
                headerStyle: tableStyles.rightSortable
            }
        ];

        return (
            <div>
                {dataComplete && dataList.length > 0 &&
                    <div className="list-table-container">
                        <ReactTable
                            key="table-missing-scans-list"
                            data={dataList}
                            columns={tableColumns}
                            defaultPageSize={50}
                            showPagination={true}
                            defaultSorted={defaultSort}
                            filterable
                            defaultFilterMethod={filterCaseInsensitive}
                            onSortedChange={(e) => this.handleSortOrFilterChange(e, this.missingScansTable)}
                            onFilteredChange={(e) => this.handleSortOrFilterChange(e, this.missingScansTable)}
                            ref={(r) => this.missingScansTable = r}
                            resizable={false}
                            minRows={1}
                        />
                    </div>
                }
                {dataComplete && dataList.length === 0 &&
                    <p>{message}</p>
                }
            </div>
        );
    }
}

MissingScansTable.propTypes = {
    listComplete: PropTypes.bool,
    onDataComplete: PropTypes.func,
    startDate: PropTypes.string,
    system: PropTypes.string
};

MissingScansTable.defaultProps = {
    listComplete: false,
    startDate: null
};

export default MissingScansTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/MissingScansTable.js